import { render, staticRenderFns } from "./NewStudioSideBar.vue?vue&type=template&id=70fb3fc5"
import script from "./NewStudioSideBar.vue?vue&type=script&lang=js"
export * from "./NewStudioSideBar.vue?vue&type=script&lang=js"
import style0 from "./NewStudioSideBar.vue?vue&type=style&index=0&id=70fb3fc5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports